document.addEventListener('DOMContentLoaded', function() {
    const menu = document.querySelector('[data-js-menu-open-drawer]');
    const menuSticky = document.querySelector('.sticky-header-burger');
    const submenus = document.querySelectorAll('.header__links-list .has-submenu')
    menu.addEventListener('click', function() {
        document.querySelector('header.header[data-section-id="header"]').classList.toggle('header--active');
    });
    menuSticky.addEventListener('click', function() {
        document.querySelector('header.header[data-section-id="header-sticky"]').classList.toggle('header--active');
    });
    submenus.forEach(submenu => {
        submenu.querySelector('.parent-menu').addEventListener('click', function(e) {
            e.preventDefault();
            submenu.classList.toggle('active')
        })
    })
    window.addEventListener('scroll', function() {
        document.querySelectorAll('header.header').forEach(header => {
            header.classList.remove('header--active');
        });
    });
});